export const APP_NAME = "Supplier Label & Shipping"